<template>
  <div class="flex flex-col w-full">
    <slot name="label">
      <label class="font-bold">{{ label }}</label>
    </slot>
    <InputGroup class="h-8">
      <ColorPicker v-model="color" pt:preview:class="rounded-r-none w-8! h-8!"></ColorPicker>
      <InputText v-on:keydown.enter.prevent size="small" :value="color" disabled></InputText>
      <IconButton icon="check" severity="success" outlined small @click="commitColor"></IconButton>
      <IconButton icon="history" severity="warning" outlined small @click="undoColor"></IconButton>
    </InputGroup>
  </div>
</template>

<script setup lang="ts">
import { type Setting } from "@/types/Settings";
import InputText from "primevue/inputtext";

const emit = defineEmits<{ (e: "commitColor", name: string, value: string | null): void }>();

interface Props {
  label: string;
  setting: Setting;
}

const props = defineProps<Props>();
const color = ref<string | null>(props.setting.settingValue);

const { history, commit, undo, redo, canUndo } = useManualRefHistory(color);

commit();

const commitColor = (): void => {
  commit();
  emit("commitColor", props.setting.settingName, color.value);
};

const undoColor = (): void => {
  undo();
  emit("commitColor", props.setting.settingName, color.value);
};
</script>
